import { readonly, ref } from 'vue'
import type { EcommerceItem } from '@/types/shared/player-config'

const showNumberFormatModal = ref<boolean>(false)
const showTransactionModal = ref<boolean>(false)
const showRadarTransactionModal = ref<boolean>(false)
const showDailyUpChallengeModal = ref<boolean>(false)
const showPathwayChallengeModal = ref<boolean>(false)
const showPuzzleChallengeModal = ref<boolean>(false)
const showPuzzlesCompletionChallengeModal = ref<boolean>(false)
const showLimitedPackModal = ref<boolean>(false)
const selectedLimitedPack = ref<EcommerceItem | null>(null)

export const useModals = () => {

  function setShowNumberFormatModal(value: boolean) {
    showNumberFormatModal.value = value
  }

  function setShowTransactionModal(value: boolean) {
    showTransactionModal.value = value
  }

  function setShowRadarTransactionModal(value: boolean) {
    showRadarTransactionModal.value = value
  }

  function setShowDailyUpChallengeModal(value: boolean) {
    showDailyUpChallengeModal.value = value
  }

  function setShowPathwayChallengeModal(value: boolean) {
    showPathwayChallengeModal.value = value
  }

  function setShowPuzzleChallengeModal(value: boolean) {
    showPuzzleChallengeModal.value = value
  }

  function setShowPuzzlesCompletionChallengeModal(value: boolean) {
    showPuzzlesCompletionChallengeModal.value = value
  }

  function setShowLimitedPackModal(value: boolean, limitedPack?: EcommerceItem | null) {
    showLimitedPackModal.value = value
    if (limitedPack !== undefined) {
      selectedLimitedPack.value = limitedPack
    }
    if (!value) {
      selectedLimitedPack.value = null
    }
  }

  return {
    showNumberFormatModal: readonly(showNumberFormatModal),
    showTransactionModal: readonly(showTransactionModal),
    showRadarTransactionModal: readonly(showRadarTransactionModal),
    showDailyUpChallengeModal: readonly(showDailyUpChallengeModal),
    showPathwayChallengeModal: readonly(showPathwayChallengeModal),
    showPuzzleChallengeModal: readonly(showPuzzleChallengeModal),
    showPuzzlesCompletionChallengeModal: readonly(showPuzzlesCompletionChallengeModal),
    showLimitedPackModal: readonly(showLimitedPackModal),
    selectedLimitedPack,
    setShowNumberFormatModal,
    setShowTransactionModal,
    setShowRadarTransactionModal,
    setShowDailyUpChallengeModal,
    setShowPathwayChallengeModal,
    setShowPuzzleChallengeModal,
    setShowPuzzlesCompletionChallengeModal,
    setShowLimitedPackModal,
  }
}